import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../component/others/Loading";

function CollectionMainPage({ categoryType }) {
  const APIURL = process.env.REACT_APP_API_URL;

  const [product, setProductData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [productAvillableCategory, setAvillableProductCategory] = useState("");
  const [activeFiltermenu, setActiveFiltermenu] = useState(null);

const [loading , setLoading] = useState(true);





  const [filters, setFilters] = useState({
    inStock: false,
    outOfStock: false,
  });

  const navigate = useNavigate();

  const getImageByIndex = (images = [], index = 0) => {
    if (!images || !images[index]) return "";

    if (typeof images[index] === "object") {
      return images[index].url;
    }
    return images[index];
  };






  const [selectedProductType, seTSelectedProductType] = useState([]);


  const [priceRange, setPriceRange] = useState({
    minPrice: null,
    maxPrice: null,
  });








  const getProducts = async () => {



    try {
      let url = `${APIURL}/api/service/products/category?category=${categoryType}`;

      if (selectedProductType && selectedProductType.length > 0) {
        url += `&productType=${selectedProductType.join(",")}`;
      }

      if (priceRange.minPrice) {
        url += `&minPrice=${priceRange.minPrice}`;
      }

      if (priceRange.maxPrice) {
        url += `&maxPrice=${priceRange.maxPrice}`;
      }


      const response = await fetch(
        url,
        // `${APIURL}/api/service/products/category?category=${categoryType}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();
      setProductData(data);
      setAvillableProductCategory(data.productTypeCount);

      setFilteredData(data.data || []);
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  };


useEffect(() => {
 const timer = setTimeout(() => {
    getProducts(); 
  }, 600); 

  return () => clearTimeout(timer);
  }, [categoryType, selectedProductType, priceRange]);






  // console.log("products", product);
  // console.log("available category", productAvillableCategory);













//  SELECTED CATEGORY  STATE  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  const handleFilterProductByCategory = (key) => {
    seTSelectedProductType((prev) => {
      if (prev.includes(key)) {
        return prev.filter((item) => item !== key);
      } else {
        return [...prev, key];
      }
    });
  };





  const handlePriceRangeChange = (value) => {
  setPriceRange(prev => ({
    ...prev,
    maxPrice: Number(value),
  }));
};




  useEffect(() => {
    if (!product.data) return;

    let result = [...product.data];

    if (filters.inStock && !filters.outOfStock) {
      result = result.filter((p) => p.quantity > 0);
    }

    if (!filters.inStock && filters.outOfStock) {
      result = result.filter((p) => p.quantity === 0);
    }

    setFilteredData(result);
  }, [filters, product]);

  /* 🔹 COUNTS */
  const totalProducts = filteredData.length;
  const inStockCount = product.data?.filter((p) => p.quantity > 0).length || 0;
  const outStockCount =
  product.data?.filter((p) => p.quantity === 0).length || 0;








// if(loading){

//   return <Loading/>
// }





  return (
    <div>
      <div className="mian-giftbox-page-content-bg">
        <div className="main-giftbox-page-content">
          <div className="main-giftpage-content-heading">
            {product?.category}
          </div>

          <div className="outer-main-data-container">
            {/* LEFT FILTER ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

            <div className="collection-filter-featues-cols">
              <div className="collection-filter-featues-stickey">
                <div className="collection-filter-featues-content">
                  <div
                    className="collection-filter-fetaues-heading-type"
                    onClick={() =>
                      setActiveFiltermenu(activeFiltermenu === "1" ? null : "1")
                    }
                  >
                    <div>Availability </div>
                    {activeFiltermenu === "1" ? (
                      <i class="fa-solid fa-angle-up"></i>
                    ) : (
                      <i class="fa-solid fa-angle-down"></i>
                    )}
                  </div>

                  {activeFiltermenu === "1" && (
                    <div className="collection-filter-featues-label-btn-style">
                      <label>
                        <input
                          type="checkbox"
                          checked={filters.inStock}
                          onChange={() =>
                            setFilters((prev) => ({
                              ...prev,
                              inStock: !prev.inStock,
                            }))
                          }
                        />
                        <span> In stock ({inStockCount}) </span>
                      </label>
                      <br />
                      <label>
                        <input
                          type="checkbox"
                          checked={filters.outOfStock}
                          onChange={() =>
                            setFilters((prev) => ({
                              ...prev,
                              outOfStock: !prev.outOfStock,
                            }))
                          }
                        />
                        <span> Out of stock ({outStockCount}) </span>
                      </label>
                    </div>
                  )}

                  <div
                    className="collection-filter-fetaues-heading-type"
                    onClick={() =>
                      setActiveFiltermenu(activeFiltermenu === "2" ? null : "2")
                    }
                  >
                    
                    <div>  Price  </div> <i class="fa-solid fa-angle-down"></i>


                  </div>

                  {activeFiltermenu === "2" && (
                    <div className="collection-main-price-filter-row">


                      <p>   <div> Min:0 </div>   <div> Max:Rs.{priceRange.maxPrice}  </div> </p>

                           <input
                                  type="range"
                                  min="0"
                                  max="3000"
                                  step="100"
                                  defaultValue={3000}
                                  onMouseUp={(e) => handlePriceRangeChange(e.target.value)}
                                  onTouchEnd={(e) => handlePriceRangeChange(e.target.value)}
                                />

                    </div>
                  )}

                  <div
                    className="collection-filter-fetaues-heading-type"
                    onClick={() =>
                      setActiveFiltermenu(activeFiltermenu === "3" ? null : "3")
                    }
                  >
                  
                    <div>product type </div>     {activeFiltermenu === "3" ? (<i class="fa-solid fa-angle-up"></i>   ) : (  <i class="fa-solid fa-angle-down"></i>   )}
                  </div>

                  {activeFiltermenu === "3" && (
                    <div  className="collection-filter-select-product-type-input-cols">
                      {productAvillableCategory &&
                        Object.entries(productAvillableCategory).map(
                          ([key, value]) => (
                            <div key={key}>
                              <input
                                type="checkbox"
                                id={key}
                                name={key}
                                value={key}
                                checked={selectedProductType.includes(key)}
                                onChange={() =>
                                  handleFilterProductByCategory(key)
                                }
                              />
                              <label htmlFor={key}>
                                {key} ({value})
                              </label>
                            </div>
                          )
                        )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}


            {


loading === true ?

        <div> 

          <Loading/>
        </div>

:
   
            <div>
              <div className="collection-filter-featues-col-top-row">
                <div>{totalProducts} Product</div>
                <div>Features</div>
              </div>

              <div className="prodict-list-main-data-container">
                {filteredData.map((e, i) => (
                  <div
                    className="prodict-list-main-data-row"
                    key={i}
                    onClick={() => navigate(`/product/${e._id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="collection-main-page-showing-image-list-container-class">
                      <img
                        src={
                          hoveredIndex === i
                            ? getImageByIndex(e.images, 1) ||
                              getImageByIndex(e.images, 0)
                            : getImageByIndex(e.images, 0)
                        }
                        alt={e.fullName}
                        onMouseEnter={() => setHoveredIndex(i)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      />
                    </div>

                    <div className="product-cl-name">
                      <p>{e.fullName}</p>
                    </div>

                    <p className="price-collect-text">
                      <span>₹ {e.mainPrice}</span>
                      <span> ₹ {e.price}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
         }


          </div>
        </div>
      </div>
    </div>
  );
}

export default CollectionMainPage;
